<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal modal-lg"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <div class="container-fluid">
            <div class="row">
              <div class="col-10">
                <h5 class="modal-title" id="orderModalLabel">
                  {{ $t('video.instruction') }}
                </h5>
              </div>
              <div class="col-2">
                <button
                  type="button"
                  class="close"
                  @click="close"
                  aria-label="Close modal"
                >
                  x
                </button>
              </div>
            </div>
          </div>
        </header>
        <section class="modal-body" id="modalDescription">
          <div class="video-container">
            <iframe
              v-if="standAlone"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/MF7u0hdOo9E?modestbranding=0"
              title="Stand alone instruction video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <iframe
              v-else
              width="560"
              height="315"
              src="https://www.youtube.com/embed/pakHBO3tzH8?modestbranding=0"
              title="Direct Injection instruction video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div
            class="btn-group d-flex justify-content-center pt-5"
            role="group"
          >
            <button
              type="button"
              @click="toggle('StandAlone')"
              class="btn"
              :class="standAlone ? 'btn-primary' : 'btn-secondary'"
            >
              Stand Alone
            </button>
            <button
              type="button"
              @click="toggle('DirectInjection')"
              class="btn"
              :class="!standAlone ? 'btn-primary' : 'btn-secondary'"
            >
              Direct Injection
            </button>
          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'InstructionVideo',
  data() {
    return {
      standAlone: true,
    };
  },
  methods: {
    toggle() {
      this.standAlone = true;
    },
    close() {
      this.$emit('instructions', false);
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  max-height: 70vh;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
